const RecaptchaHelper = {
  ProcessToken: (token) => {
    const opts = {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(token),
    };

    return fetch(
      `${process.env.REACT_APP_VELOSURE_API_URL}/api/Recaptcha/ProcessToken`,
      opts
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then((text) => {
        // Try to parse as JSON first, fallback to parsing as number
        try {
          const data = JSON.parse(text);
          return data?.score ?? parseFloat(text) ?? 0;
        } catch {
          return parseFloat(text) ?? 0;
        }
      })
      .catch((error) => {
        console.error("RecaptchaHelper error:", error);
        throw error; // Re-throw to be handled by caller
      });
  },
};
export default RecaptchaHelper;
